module.exports = __webpack_public_path__ + "static/media/f1.dc560111.jpg";